module.exports = __webpack_public_path__ + "img/article4-mob.773ff523.png";